import { oracleGuideOnSidePlugin, PLUGIN_NAME } from './oracle-guide-on-side-plugin'
import {
  OracleGuideOnSideComponent,
  COMPONENT_NAME,
} from './oracle-guide-on-side-component'
import {
  OracleGuideOnSideButton,
  BUTTON_COMPONENT_NAME,
} from './oracle-guide-on-side-button'

export { PLUGIN_NAME }
export { oracleGuideOnSidePlugin }
export { OracleGuideOnSideComponent }
export { OracleGuideOnSideButton, BUTTON_COMPONENT_NAME }

/**
 * Register the Oracle Guide on Side plugin and component with video.js.
 *
 * Call this function once during app initialization, before any player
 * instances are created that need to use this plugin.
 *
 * @param {Object} videojsInstance - The video.js instance to register with
 */
export function register (videojsInstance = window.videojs) {
  // Register component first (plugin depends on it)
  videojsInstance.registerComponent(COMPONENT_NAME, OracleGuideOnSideComponent)

  // Register button component
  videojsInstance.registerComponent(BUTTON_COMPONENT_NAME, OracleGuideOnSideButton)

  // Register plugin function (basic plugin pattern, not class-based)
  videojsInstance.registerPlugin(PLUGIN_NAME, oracleGuideOnSidePlugin)
}
